import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearLeftWorkAreaState, setLeftWorkAreaState } from '../../../redux/actions/product2dActions';

/**
 * Implementation extracted from LeftWorkAreaContainer.js as it will be reused in 
 * MobileView Footer
 */
export const useEditModeCapture = ()=>{
    const dispatch = useDispatch();

    const makFabric = useSelector((state: any) => state.makFabric)
    const activeObj = useSelector((state:any) => state.activeObj)
    const activeObjs = useSelector((state:any) => state.activeObjs)

    const LWAState = useSelector((state:any) => state.LWAState)

    useEffect(() => {
        if (makFabric) {
          switch (activeObj && activeObjs.length === 1 && activeObj.type) {
            case "size":
              dispatch(setLeftWorkAreaState("EDIT_TEXT"))
              break
            case "text":
              dispatch(setLeftWorkAreaState("EDIT_TEXT"))
              break
            case "image":
              dispatch(setLeftWorkAreaState("EDIT_IMG"))
              break
            default:
              dispatch(clearLeftWorkAreaState())
              break
          }
        }
      }, [activeObj, activeObjs.length, dispatch, makFabric])

      return LWAState
}